import { useWindowSize } from "@hooks";
import clsx from "clsx";
import { element, object, oneOfType, string } from "prop-types";
import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Explorer, Filters, SearchResult } from "./components";

import styles from "./styles/CourseExplorer.module.css";

const CourseExplorer = ({ title, extraSearchParams, courseType }) => {
  // state
  const [filterVisible, setFilterVisible] = useState(false);

  // variables

  // logics before hooks

  // hooks
  const { width } = useWindowSize();

  // logics
  const toggleFilterUI = () => setFilterVisible(!filterVisible);

  const hideFilterUI = () => width < 992 && setFilterVisible(false);

  // UI partials

  // effects

  // render
  return (
    <Container className="position-relative">
      {title ? <h3 className="my-4">{title}</h3> : null}
      <Explorer toggleFilterUI={toggleFilterUI} />
      <div className={styles.content}>
        <div
          className={clsx(
            styles.filterContainer,
            filterVisible ? styles.filterVisible : ""
          )}
        >
          <div
            className={clsx(
              styles.filter,
              filterVisible ? styles.filterVisible : ""
            )}
          >
            <div className={styles.filterMask} onMouseDown={hideFilterUI}></div>
            <div className={clsx(styles.filterContent, "border")}>
              <Filters hideFilterUI={hideFilterUI} />
            </div>
          </div>
        </div>
        <div className={styles.resultContainer}>
          <SearchResult
            filterUIVisible={filterVisible}
            extraSearchParams={extraSearchParams}
            courseType={courseType}
          />
        </div>
      </div>
    </Container>
  );
};

/* required: display name */
CourseExplorer.displayName = "CourseExplorer";

/* required: props types */
CourseExplorer.propTypes = {
  title: oneOfType([string, element]),
  extraSearchParams: object,
  courseType: string,
  courseReducerName: string,
};

/* required: default props */
CourseExplorer.defaultProps = {
  title: "",
  extraSearchParams: {},
  courseType: "buy",
};

export { CourseExplorer };
